module.exports = __webpack_public_path__ + "static/media/tab_home.eb5ba59d.png";